//import 'rxjs/add/operator/do';

import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ClientStorageService } from "@app/services";
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
//import 'rxjs/add/operator/catch';
import {Router} from '@angular/router';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';

/**
 * Interceptor replaces some of the auth-http.service.ts functionality.
 */
@Injectable()
export class OutdoorAccessApiInterceptor implements HttpInterceptor {
  private readonly _componentName = 'OutdoorAccessApiInterceptor';

  private apiBaseUrl = environment.apiUrl;

  /**
   * The default content type to use
   */
  private defaultContentType = 'application/json; charset=utf-8';

  public constructor(private clientStorage: ClientStorageService, private injector : Injector) {}

  /**
   * Is verbose logging enabledisApiUrl
   */
  private get verboseLogging(): boolean {
    return false;
    //return true;
  }

    /**
   * Intercepts an HTTP Request
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log(`${this._className} intercept method: ${req.method}, url: ${req.url}`);

    // If this isn't an API URL, we don't do anything
    // and just handle the request normally.
    if (!this.isOaApiCall(req.url)) {
      return next.handle(req);
    }

    // Request URL is an API Url, so we apply the intercept changes:
    let interceptUrl = this.getUrl(req.url);

    let headers = new HttpHeaders();

    // console.log(`${this._className} interceptUrl: ${interceptUrl}`);

    // If we have a token in client storage, set the Authorization header
    const auth_token = this.clientStorage.auth_token;
    if (auth_token !== undefined) {
      headers = headers.set('Authorization', `Bearer ${auth_token}`);
      // console.log(`${this._className} Authorization Bearer Set.`);
    }

    // Set the Content-Type and Accept Header values
    headers = headers.set('Content-Type', this.defaultContentType).set('Accept', 'application/json');

    // Make a clone of the request
    const cloneRequest = req.clone({ url: interceptUrl, headers });

    // And send it away!!!
    return next.handle(cloneRequest)
      .pipe(
        tap({
          next: (event) => {},
          error: (err) => { 
            if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
              //this.clientStorage.auth_token = ''; 
              this.injector.get(UserService).signout();
              //this.injector.get(ToasterService).showError(`Unauthorized`, errorMsg);
              this.injector.get(Router).navigateByUrl(`/user/signin`);
              
            }
          } 
        })
      );
  }

  /**
   * Tests to see if the URL is an API url
   * @param url
   */
  private isOaApiCall(url: string): boolean {
    // if this is already an API Url, return true
    if (url.startsWith(this.apiBaseUrl)) {
      if (this.verboseLogging) {
        console.log(`${this._componentName}.isApiUrl - return true because startsWith base url.`, url);
      }

      return true;
    }

    // Not an API Url, leave it alone.
    if (url.startsWith('http')) {
      if (this.verboseLogging) {
        console.log(`${this._componentName}.isApiUrl - return false because does not start with http.`, url);
      }
      return false;
    }

    if (this.verboseLogging) {
      console.log(`${this._componentName}.isApiUrl - return true because no other falsy conditions met.`, url);
    }
    return true;
  }

  /**
   * Modifies the URL, if needed, by appended the API Base URL to the beginning of the string.
   * @param url
   */
  private getUrl(url: string): string {
    if (url.startsWith(this.apiBaseUrl)) {
      return url;
    }

    if (this.isOaApiCall(url)) {
      if (url.startsWith('api')) {
        let resourcePath = url.substring(3);

        if (this.apiBaseUrl.endsWith('/') && resourcePath.startsWith('/')) {
          resourcePath = url.substring(4);
        }

        return `${this.apiBaseUrl}${resourcePath}`;
      } else {
        return `${this.apiBaseUrl}${url}`;
      }
    } else {
      return url;
    }
  }
}
